/**
 * Formats author name to read first name last name
 * @param {string} authorName The author name to format. NOTE: Callers should pass in the "main_name" or "author" version of the author name.  (not full_name, full_author)
 * @return {string} The author name formatted in "First, Last" order
 */
export function formatAuthorName(authorName) {
	var formattedAuthorName = "";
	try {
		if (authorName) {
			let [lastName, firstName] = authorName.split(",").map(str => str.trim());
			if (firstName) {
				formattedAuthorName = firstName + " " + lastName;
			} else {
				formattedAuthorName = lastName;
			}
		}
	} catch (e) {
		return formattedAuthorName;
	}

	return formattedAuthorName.trim();
}




// WEBPACK FOOTER //
// ./src/lib/AuthorUtility.js